import React from "react";
import { ReactComponent as ChevronDownIcon } from "assets/icons/dropdown-arrow.svg";

const sortOptions = [
  { id: "0", value: "deceasedName", displayName: "Sort by Name" },
  { id: "1", value: "deceasedBirthDate", displayName: "Sort by DOB" },
  { id: "2", value: "deceasedDeathDate", displayName: "Sort by DOD" },
];

const SortOptionsForMobile = ({ sortBy, setSortBy }) => (
  <div className="relative max-w-[20rem] w-full mx-auto block md:hidden">
    <select
      id="sort_by"
      name="sort-by"
      className="mx-auto appearance-none truncate max-w-[20rem] w-full px-3 py-2 pr-9 leading-normal bg-white border border-obituary-brown-100 focus:ring-0 focus:outline-0"
      value={sortBy}
      onChange={(e) => setSortBy(e.target.value)}
    >
      {sortOptions.map((option) => (
        <option key={option.id} value={option.value}>
          {option.displayName}
        </option>
      ))}
    </select>
    <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
      <ChevronDownIcon className="size-4 text-obituary-brown-300" />
    </div>
  </div>
);

export default SortOptionsForMobile;
